// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__fv6-X","errorLogs":"EditorFooter_errorLogs__3p7gq"};